import { rest } from 'utils';

export default {
  get: ({ dcId, id }) => rest.get({ url: `datacenters/${dcId}/servers/${id}?depth=4` }),
  create: ({ dcId, server }) => rest.post({ url: `datacenters/${dcId}/servers`, body: server }),
  update: ({ dcId, id, properties }) => rest.patch({ url: `datacenters/${dcId}/servers/${id}`, body: properties }),
  action: ({ dcId, id, action }) => rest.request({ url: `datacenters/${dcId}/servers/${id}/${action}`, method: 'POST', responseType: null }),
  delete: ({ dcId, id }) => rest.delete({ url: `datacenters/${dcId}/servers/${id}` }),
  attachCdRom: ({ dcId, id, cdRomId }) => rest.post({ url: `datacenters/${dcId}/servers/${id}/cdroms`, body: { id: cdRomId } }),
  getCdRom: ({ dcId, id, cdromId }) => rest.get({ url: `datacenters/${dcId}/servers/${id}/cdroms/${cdromId}?depth=4` }),
  deattachCdRom: ({ dcId, id, cdRomId }) => rest.delete({ url: `datacenters/${dcId}/servers/${id}/cdroms/${cdRomId}` }),
  attachVolume: ({ dcId, id, volumeId }) => rest.post({ url: `datacenters/${dcId}/servers/${id}/volumes`, body: { id: volumeId } }),
  getVolume: ({ dcId, id, volumeId }) => rest.get({ url: `datacenters/${dcId}/servers/${id}/volumes/${volumeId}?depth=4` }),
  deattachVolume: ({ dcId, id, volumeId }) => rest.delete({ url: `datacenters/${dcId}/servers/${id}/volumes/${volumeId}` }),
  getAccessToken: ({ dcId, id }) => rest.get({ url: `datacenters/${dcId}/servers/${id}/token` }),
};
